package com.milta.core.localization.translations.it

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Aggiorna",
    expandedStopsTitle = "Fermate",
    stopStatusWaitingLabel = "In attesa",
    stopStatusFailedLabel = "Non consegnato",
    filterAllDriversLabel = "Tutti gli autisti",
)
